import React from "react";
import { useAppSelector } from "../../../../store";
import { formatNumber, formatCurrency } from "../../../../utils/formatting";
import { selectHullAndArmorStats } from "../../../../store/selectors/shipBuilderSelectors";

export const PowerPlantSummary: React.FC = () => {
  const powerPlant = useAppSelector((state) => state.shipBuilder.powerPlant);
  const hullAndArmorStats = useAppSelector(selectHullAndArmorStats);
  const solarCoatingPower = hullAndArmorStats?.solarCoatingPower || 0;

  if (!powerPlant) {
    return null;
  }

  const { weight, power, cost, maintenanceCost } = powerPlant;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-800 text-white p-4 shadow-lg z-10">
      <div className="container mx-auto grid grid-cols-4 gap-4 items-center text-center">
        <div>
          <span className="text-gray-400 block text-sm">Power Plant Size</span>
          <span className="text-xl font-bold">{formatNumber(weight)} tons</span>
        </div>
        <div>
          <span className="text-gray-400 block text-sm">Generated Power</span>
          <span className="text-xl font-bold">
            Power: {formatNumber(power)} Power
            {solarCoatingPower > 0 && (
              <>
                <span className="text-gray-400"> + </span>
                <span className="text-yellow-300">
                  {formatNumber(solarCoatingPower)} Power (Solar Coating)
                </span>
              </>
            )}
          </span>
        </div>
        <div>
          <span className="text-gray-400 block text-sm">Total Cost</span>
          <span className="text-xl font-bold text-green-400">
            {formatCurrency(cost)}
          </span>
        </div>
        <div>
          <span className="text-gray-400 block text-sm">
            Monthly Maintenance
          </span>
          <span className="text-xl font-bold text-yellow-400">
            {formatCurrency(maintenanceCost)}
          </span>
        </div>
      </div>
    </div>
  );
};
